module.exports = __webpack_public_path__ + "static/media/coding.6566dc67.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/coding.png
// module id = 84
// module chunks = 0